<script setup lang="ts">
import AppShell from './components/layout/AppShell.vue'
import ToastHost from './components/ui/ToastHost.vue'
import ConfirmDialog from './components/ui/ConfirmDialog.vue'
</script>

<template>
  <AppShell />
  <ToastHost />
  <ConfirmDialog />
</template>
